import React, { useMemo } from 'react'
import { Dialog, DialogContent, DialogActions, Typography, Button, Box } from '@mui/material'
import { User } from 'types'

interface GoogleSignatureModalProps {
  isOpen: boolean
  onClose: () => void
  user: User
  onUpdateSignature: () => void
  generateSignature: () => string
  generateRenderSignature: () => string
  status?: string | null
}

const GoogleSignatureModal: React.FC<GoogleSignatureModalProps> = ({
  isOpen,
  onClose,
  user,
  onUpdateSignature,
  generateSignature,
  generateRenderSignature,
  status,
}) => {
  const signatureHtml = useMemo(() => generateSignature(), [generateSignature])
  const generateSignatureHtml = useMemo(() => generateRenderSignature(), [generateRenderSignature])

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      {/* <DialogTitle>User Settings</DialogTitle> */}

      <DialogContent>
        {/* <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar src={user.image_512} alt={user.name} sx={{ width: 80, height: 80 }}>
              <Typography>{user.firstName[0]}</Typography>
              <Typography>{user.lastName[0]}</Typography>
            </Avatar>
          </Grid>
          <Grid item xs>
            <Typography variant="h6" sx={{ color: 'text.primary' }}>
              {user.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user.role}
            </Typography>
          </Grid>
        </Grid> */}

        {/* <Box mt={3}>
          <Typography variant="body2">
            <strong>Email:</strong> {user.email}
          </Typography>
          <Typography variant="body2">
            <strong>Phone:</strong> {user.phone ? user.phone : <em style={{ color: '#888' }}>Not provided</em>}
          </Typography>
        </Box> */}

        <Box mt={4}>
          <Typography variant="h6" gutterBottom>
            Signature Preview
          </Typography>
          <Box
            sx={{
              border: '1px solid #ccc',
              padding: 2,
              borderRadius: 1,
              textAlign: 'left',
              color: 'text.primary',
              backgroundColor: 'background.default',
            }}
            dangerouslySetInnerHTML={{ __html: generateSignatureHtml }}
          />

          {status && (
            <Typography mt={2} color={status.includes('✅') ? 'success.main' : 'error.main'}>
              {status}
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="primary" fullWidth onClick={onUpdateSignature}>
          Update My Gmail Signature
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default GoogleSignatureModal
